import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateCustomElementComponent } from './report-template/create-custom-element/create-custom-element.component';
import {
  BeforeunloadGuard,
  ReportTemplateDesignComponent,
} from './report-template/report-template-design/report-template-design.component';
import {
  BeforeunloadGuardNew,
  ReportTemplateNewDesignComponent
} from './report-template/report-template-new-design/report-template-new-design.component';
import { ReportTemplateComponent } from './report-template/report-template.component';
import { VisolAuthGuard } from './auth/visol-auth.guard';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { RequestAppAccessComponent } from '@osc-utils/components/request-app-access/request-app-access.component';
import { ReportBuilderSubscriptionGuard } from '@osc-utils/guards/report-builder-subscription.guard';
import { AuthFailureGuard, AuthLogoutGuard } from '@evc/platform';
import { Http403ForbiddenComponent } from '@osc-utils/components/http-403-forbidden/http-403-forbidden';

const routes: Routes = [
  {
    path: '403',
    component: Http403ForbiddenComponent,
  },
  {
    path: '',
    redirectTo: '/template-list',
    pathMatch: 'full',
  },
  {
    path: 'template-list',
    canActivate: [
      AuthGuard,
      VisolAuthGuard,
      ReportBuilderSubscriptionGuard
    ],
    component: ReportTemplateComponent,
  },
  {
    path: 'report-template-design/:reportTemplateId',
    canActivate: [
      AuthGuard,
      VisolAuthGuard,
      ReportBuilderSubscriptionGuard
    ],
    component: ReportTemplateDesignComponent,
    canDeactivate: [BeforeunloadGuard],
  },
  {
    path: 'report-template-new-design/:reportTemplateId',
    canActivate: [AuthGuard, ReportBuilderSubscriptionGuard],
    component: ReportTemplateNewDesignComponent,
    canDeactivate: [BeforeunloadGuardNew],
  },
  {
    path: 'create-custom-element',
    canActivate: [AuthGuard],
    component: CreateCustomElementComponent,
  },
  {
    path: 'create-custom-element',
    canActivate: [AuthGuard],
    component: CreateCustomElementComponent,
  },
  {
    path: 'access-page',
    component: RequestAppAccessComponent
  },
  {
    path: 'logout',
    canActivate: [AuthLogoutGuard],
    data: { logout: true }, // to prevent it from fetching any token
    component: RequestAppAccessComponent, // can be any component...
  },
  {
    path: 'auth-fail',
    canActivate: [AuthFailureGuard],
    component: RequestAppAccessComponent, // can be any component
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
